var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerEcontdrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "marker-econtdrive",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 48",
    style: {
      enableBackground: "new 0 0 32 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#003F85;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dropshape",
    className: "st0",
    d: "M32,15.4c0,2.6-0.6,5.2-1.7,7.5L17,47.4c-0.3,0.6-1,0.8-1.6,0.5c-0.2-0.1-0.3-0.3-0.5-0.5 L1.6,22.6c-1-2.3-1.6-4.7-1.6-7.2C0,6.7,7.4,0,16,0S32,6.7,32,15.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.7,15.1L27.7,15.1L27.7,15.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.3-0.4-0.7-0.6-1.2-0.7c-0.1-0.1-0.3-0.2-0.5-0.3 c-0.7-0.4-1.5-0.7-2.3-0.8l-0.8-0.2c-0.1,0-0.2-0.1-0.3-0.2c-1.4-1.5-3.1-2.7-5-3.4c-2.3-0.6-4.7-0.4-6.9,0.7 c-1.9,1-3.5,2.4-4.9,4.1c-0.7,0.7-1.4,1.5-1.8,2.4c-0.2,0.5-0.2,0.9-0.2,1.4c0,0.7,0.4,1.3,1,1.7l0.8,0.4l-0.1-0.9 c0-0.1,0-0.3,0-0.4c0-1.7,1.4-3.2,3.2-3.2c1.7,0,3.2,1.4,3.2,3.2c0,0.2,0,0.4,0,0.6l-0.1,0.5h8.3L19.6,19c0-0.2,0-0.4,0-0.6 c0-1.7,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2c0,0.2,0,0.4,0,0.5l-0.1,0.7l0.7-0.1c0.9-0.2,1.6-0.8,1.9-1.6c0.1-0.3,0.2-0.6,0.2-0.9 C28.4,16.3,28.2,15.6,27.7,15.1z M13.1,10.1v3.9l-5.2,0C9.3,12,10.6,10.5,13.1,10.1L13.1,10.1z M14.3,14.1V9.9 c0.2,0,0.5-0.1,0.7-0.1c2.9,0,5.6,1.6,6.9,4.2L14.3,14.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.4,16.5c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4C10.7,17.6,9.7,16.5,8.4,16.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.7,16.5c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4C25.1,17.6,24,16.5,22.7,16.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerEcontdrive);
export default __webpack_public_path__ + "static/media/marker-econtdrive.d7b0e2232cbb3020f963d5f5cedb3907.svg";
export { ForwardRef as ReactComponent };